export default "__VITE_ASSET__d5e814da__"